module.exports = "/_next/static/images/code-card-bg-de0a10dd86c09f33f0d1d5f7bd036544.png.webp";